import informationService from "../services/informationService";

const USER_ONLINE = "user_online";
const USER_CONNECTED = "user_connected";
const USER_DISCONNECTED = "user_disconnected";
const BLOCK_INPUT = "block_input";
const UNBLOCK_INPUT = "unblock_input";
const UPDATE_INPUT = "update_input";

const documentSocket = {
  created() {},
  data() {
    return {
      usersOnline: [],
      blockedInputsUsers: [],
      blockedInputs: [],
      keyFocus: null,
      field_values: {},
      noInternet: false,
      checkingInternet: false,
      docID: null,
    };
  },
  methods: {
    reconnect: function () {
      if (this.localMode) return;
      this.$connect();
      if (this.docID) {
        this.joinDocument(this.docID);
      }
    },
    checkInternet: function () {
      if (this.localMode) return;
      console.log("check internet");
      setTimeout(() => {
        this.checkingInternet = false;
        informationService.ping().then(
          () => {
            this.noInternet = false;
          },
          () => {
            this.checkingInternet = true;
          }
        );
      }, 3000);
    },
    blockInput: function (key) {
      if (this.localMode) {
        this.keyFocus = key;
        return;
      }
      informationService.ping().then(
        () => {
          // commit send message
          this.$store.dispatch("blockInput", key);
          // maybe add to store
          this.keyFocus = key;
        },
        () => {
          this.noInternet = true;
          this.$disconnect();
          this.checkInternet();
        }
      );
    },
    updateErrors: function (errors) {
      if (this.localMode) return;
      informationService.ping().then(
        () => {
          // dispatch send message
          this.$store.dispatch("updateErrors", errors);
        },
        () => {
          this.noInternet = true;
          this.$disconnect();
          this.checkInternet();
        }
      );
    },
    unblockInput: function (key) {
      // Local (chatbot) mode: the value already lives in the local
      // field_values via v-model; nothing to persist.
      if (this.localMode) {
        this.keyFocus = null;
        return;
      }
      informationService.ping().then(
        () => {
          // dispatch send message
          this.$store.dispatch("unblockInput", {
            key: key,
            value: this.field_values[key],
          });
          this.keyFocus = null;
        },
        () => {
          this.noInternet = true;
          this.$disconnect();
          this.checkInternet();
        }
      );
    },
    updateInput: function (key) {
      // Local (chatbot) mode: do NOT ping / dispatch / send over the socket.
      // The answer is already in the local field_values (v-model); it will be
      // collected into a dict and sent only at render time. No DB write.
      if (this.localMode) return;
      informationService.ping().then(
        () => {
          // dispatch send message
          this.$store.dispatch("updateInput", {
            key: key,
            value: this.field_values[key],
          });
        },
        () => {
          this.noInternet = true;
          this.$disconnect();
          this.checkInternet();
        }
      );
    },
    joinDocument: function (document_id) {
      if (this.localMode) {
        this.docID = document_id;
        return;
      }
      informationService.ping().then(
        () => {
          this.docID = document_id;
          this.$store.dispatch("joinDocument", document_id);
        },
        () => {
          this.noInternet = true;
          this.$disconnect();
          this.checkInternet();
        }
      );
    },
    leaveDocument: function () {
      this.docID = null;
      if (this.localMode) return;
      this.$store.dispatch("leaveDocument");
    },
    socketFunction: function (message) {
      if (message.type in this.extraEvents) {
        this.extraEvents[message.type](message);
      }
    },
  },
  computed: {
    socketConnected() {
      return this.$store.state.sockets.socket.isConnected;
    },
    blockAllInputs() {
      // Local (chatbot) mode never depends on a socket, so inputs are always
      // editable.
      if (this.localMode) return false;
      return !this.$store.state.sockets.socket.isConnected || this.noInternet;
    },
    actualMessage() {
      return this.$store.state.sockets.actualMessage;
    },
  },
  watch: {
    // eslint-disable-next-line
    checkingInternet(newValue, oldValue) {
      if (newValue) {
        this.checkInternet();
      }
    },
    noInternet(newValue, oldValue) {
      if (oldValue === true && !newValue) {
        console.log("Reconnecting...");
        this.reconnect();
      }
    },
    // eslint-disable-next-line
    socketConnected(newValue, oldValue) {
      if (this.localMode) return;
      if (newValue) {
        this.joinDocument(this.$store.state.sockets.activeDocument);
      }
    },
    // eslint-disable-next-line
    blockAllInputs(new_val, old_val) {
      if (new_val) {
        this.$toasted.info(
          "Hay problemas con tu conexión, recarga el sitio para volver a conectarte.",
          { position: "top-right" }
        );
      }
    },

    // eslint-disable-next-line
    actualMessage(new_val, old_val) {
      // Local (chatbot) mode ignores all socket traffic from other documents.
      if (this.localMode) return;
      const message = new_val;
      switch (message.type) {
        case USER_CONNECTED:
          if (
            !this.usersOnline.includes(message.user_name) ||
            message.user_name === "Anon"
          ) {
            if (
              message.user_name === this.$store.state.login.email ||
              message.user_name === "Anon"
            ) {
              if (!this.usersOnline.includes(message.user_name)) {
                this.$toasted.success(
                  "Te has conectado a trabajar en este documento"
                );
                this.usersOnline.push(message.user_name);
              }
            } else {
              this.$socket.sendObj({ type: USER_ONLINE, key: this.keyFocus });
              this.usersOnline.push(message.user_name);
              this.$toasted.success(
                message.user_name.concat(" se ha conectado")
              );
            }
          }
          break;
        case USER_ONLINE:
          if (!this.usersOnline.includes(message.user_name)) {
            this.usersOnline.push(message.user_name);
            if (message.key !== null && message.user_name !== "Anon")
              this.blockedInputs.push(message.key);
            this.blockedInputsUsers.push(message.user_name);
          }
          break;
        case BLOCK_INPUT:
          if (
            message.user !== this.$store.state.login.email &&
            message.user !== "Anon"
          ) {
            this.blockedInputs.push(message.input);
            this.blockedInputsUsers.push(message.user);
          }
          break;
        case UNBLOCK_INPUT:
          if (
            this.blockedInputs.includes(message.input) &&
            message.user !== "Anon"
          ) {
            this.blockedInputs.splice(
              this.blockedInputs.indexOf(message.input),
              1
            );
            this.blockedInputsUsers.splice(
              this.blockedInputsUsers.indexOf(message.user),
              1
            );
          }
          this.field_values[message.input] = message.value;
          break;
        case UPDATE_INPUT:
          if (
            message.user !== this.$store.state.login.email &&
            message.user !== "Anon"
          ) {
            if (message.value === "True") {
              // this.field_values[message.input] = true;
              this.$set(this.field_values, message.input, true);
            } else {
              this.$set(this.field_values, message.input, message.value);
              // this.field_values[message.input] = message.value;
            }
          }
          break;
        case USER_DISCONNECTED:
          if (
            message.user !== this.$store.state.login.email &&
            message.user !== "Anon"
          ) {
            if (
              this.blockedInputsUsers.includes(message.user) &&
              message.user_name !== "Anon"
            ) {
              this.blockedInputs.splice(
                this.blockedInputsUsers.indexOf(message.user),
                1
              );
              this.blockedInputsUsers.splice(
                this.blockedInputsUsers.indexOf(message.user),
                1
              );
            }
            this.usersOnline.splice(this.usersOnline.indexOf(message.user), 1);
            this.$toasted.success(message.user.concat(" se ha desconectado"));
          }
          if (message.user === "Anon") {
            this.blockedInputs = [];
            this.blockedInputsUsers = [];
          }
          break;
        default:
          this.socketFunction(message);
      }
    },
  },
};

export default documentSocket;
